export default __webpack_public_path__ + "static/media/SN.45a8efb9.png";